import React from 'react'
import { SquaredTable } from './SquaredTable'
import { CircleTable } from './CircleTable'

export const Table = ({ shape, positionLeft = 0, positionTop = 0, ...props }) => {
	switch (shape) {
		case 'round':
			return (
				<CircleTable
					{...props}
					position={[positionLeft, 0, positionTop]}
				/>
			)
		default:
			return (
				<SquaredTable
					{...props}
					position={[
						positionLeft - props.width / 2,
						0,
						positionTop - props.height / 2
					]}
				/>
			)
	}
}

export const getTableTextWidth = (caption = '') => (caption.length - 1) * 7